import { addMilliseconds, endOfDay, isAfter, startOfDay } from 'date-fns';

/**
 * This function is used to calculate the time based on the selected date and the scroll position on the EPG timeline.
 * @param {number} selectedDate A timestamp from the selected date.
 * @param {number} scrollPosition The scroll position.
 * @return {number} The timestamp calculated from the selected date and the scroll position. */
const scrollPositionToTime = (
    selectedDate: number,
    scrollPosition: number,
): number => {
    const hours = Math.floor(scrollPosition);
    const decPart = scrollPosition - hours;
    const minutes = Math.floor(decPart * 60);
    const seconds = Math.floor(((decPart * 60) % 1) * 60);
    const milliseconds = Math.floor(((decPart * 60) % 1) * 60 * 1000);
    const inMilliseconds =
        (hours * 60 * 60 + minutes * 60 + seconds) * 1000 + milliseconds;

    const time = addMilliseconds(
        new Date(startOfDay(selectedDate)),
        inMilliseconds,
    ).getTime();

    if (isAfter(time, endOfDay(selectedDate))) {
        return endOfDay(selectedDate).getTime();
    }

    return time;
};

export default scrollPositionToTime;
